import { createSlice } from '@reduxjs/toolkit';
import type { InvitationState } from './types';

const initialState: InvitationState = {
  isLoading: false,
  error: false,
  invitations: []
};

export const slice = createSlice({
  name: 'invitation',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getInvitations(state, action) {
      state.invitations = action.payload;
    },
    addInvitation(state, action) {
      state.invitations.push(action.payload);
    },
    acceptInvitation(state, action) {
      const updatedInvitations = state.invitations.map((invitation) =>
        invitation.guid === action.payload.invitationGuid
          ? {
              ...invitation,
              ...action.payload,
              isUnRead: false
            }
          : invitation
      );
      state.invitations = updatedInvitations;
    },
    declineInvitation(state, action) {
      const updatedInvitations = state.invitations.filter(
        (invitation) => invitation.guid !== action.payload.invitationGuid
      );
      state.invitations = updatedInvitations;
    },
    deleteInvitation(state, action) {
      state.invitations = state.invitations.filter(
        (invitation) => invitation.guid !== action.payload.invitationGuid
      );
    }
  }
});

// Reducer
export default slice.reducer;
